module.exports = __webpack_public_path__ + "static/GUILLAUME BAREIL-32dbd7729b563ebc20dae0b951f43bb9.png";